import React, { useState, useEffect } from 'react';
import { formatMoneda } from '../../../util/varios';
import { TableBody, TableRow, TableCell, InputAdornment } from '@mui/material';

import { Mensaje, MensajeSiNo } from '../../mensajes';

import { Dimmer } from "../../spinner";

import useTableFijo from "../../useTableFijo"
import moment from 'moment';

import { FETCH_ELIMINAR_PAGO_WEB_QUERY } from '../../../util/graphqlIndustria';

const headCells = [
    { id: 'numfactura', label: 'Nº FACTURA', width: '50px', textAlign: "center", backgroundColor: "rgba(5, 81, 130, 1)", fontSize: "10px", color: "white"  },
    { id: 'periodo', label: 'PERIODO', width: '50px', textAlign: "center", backgroundColor: "rgba(5, 81, 130, 1)", fontSize: "10px", color: "white"  },
    { id: 'numdocumento', label: 'Nº DOCUMENTO', width: '150px', textAlign: "center", backgroundColor: "rgba(5, 81, 130, 1)", fontSize: "10px", color: "white"  },
    { id: 'tippago', label: 'TIPO', width: '100px', textAlign: "center", backgroundColor: "rgba(5, 81, 130, 1)", fontSize: "10px", color: "white"  },
    { id: 'banco', label: 'BANCO', width: '150px', textAlign: "center", backgroundColor: "rgba(5, 81, 130, 1)", fontSize: "10px", color: "white"  },
    { id: 'fecha', label: 'FECHA', width: '80px', textAlign: "center", backgroundColor: "rgba(5, 81, 130, 1)", fontSize: "10px", color: "white"  },
    { id: 'monto', label: 'MONTO', width: '120px', textAlign: "center", backgroundColor: "rgba(5, 81, 130, 1)", fontSize: "10px", color: "white"  },
    { id: 'status', label: 'STATUS', width: '100px', textAlign: "center", backgroundColor: "rgba(5, 81, 130, 1)", fontSize: "10px", color: "white"  },
    { id: 'accion', label: 'OPCIONES', width: '100px', textAlign: "center", backgroundColor: "rgba(5, 81, 130, 1)", fontSize: "10px", color: "white" },
]


const TablaRelacionPagosWeb = props => {
    const [titulo, setTitulo] = useState();
    const [msg, setMsg] = useState();
    const [mostrar, setMostrar] = useState(false);
    const [mostrar3, setMostrar3] = useState(false);
    const [mostrar4, setMostrar4] = useState(false);
    const [contar, setContar] = useState(0);
    const [contar3, setContar3] = useState(0);
    const [activate, setActivate] = useState(false);
    const [numFac, setNumFact] = useState();
    const [periodo, setPeriodo] = useState();

    const [records, setRecords] = useState([]);

    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } })

    const {
        TblContainer,
        TblHead,
        TblPagination,
        recordsAfterPagingAndSorting
    } = useTableFijo(records, headCells, filterFn, 320);

    const [url, setUrl] = useState('');

    useEffect(() => {

        let op = require('../../../../src/modulos/datos');
        if (props.tabpagow) {
            setRecords(props.tabpagow);
            console.log(props.tabpagow)
        }

        if (op.reportes != null) {

            setUrl(op.reportes.trim());

        } else {
            setUrl('');
        }


    }, [props.tabpagow]);

   
  

    const eliminarPago = (id, peri, status) => (event) => {
        if (status === 'RECHAZADO') {
            setNumFact(id);
            setPeriodo(peri);
            setTitulo("Corfirmar");
            setMsg("Esta seguro de eliminar el Pago de el(los) periodo(s) "+peri+" ?");
            setMostrar3(true);
        } else {
            setTitulo("Advertencia");
            setMsg("No se puede eliminar el Pago por que se encuentra " + status + ".");
            setMostrar(true);
        }
    };

    const handleCloseNo = () => {
        setMostrar3(false);
    }

    const handleCloseSi = () => {
        setContar(0);
        setMostrar3(false);
        setActivate(true);
       
    }

    const handleCloseMensa = () => {
        setMostrar(false);
        
    }

    return (
        <div className="card">
            <Mensaje titulo={titulo} mensaje={msg}
                show={mostrar}
                onHide={handleCloseMensa} />

            <MensajeSiNo titulo={titulo} mensaje={msg}
                show={mostrar3}
                onHideSi={handleCloseSi} onHideNo={handleCloseNo} />
            
<Dimmer active={activate} inverted>
       
      </Dimmer>
            <div className="card-body">
                <div className="content" >
                    <div className="container">

                        <div className="row">

                            <div className="col-md-12" style={{ margin: "auto" }} >
                            <TblContainer container={{ height: 250, width: '100%', overflow: 'auto', padding: '2px' }} >

                                    <TblHead />

                                    <tbody>
                                         {

                                            records && records.map((item, index) => (
                                                <tr key={item.periodo+ item.numfactura + item.numdocumento} style={{ padding: "0" }}>
                                                    <td style={{ fontSize: "10px", textAlign: "center" }}>{item.numfactura.trim()}</td>
                                                    <td style={{ fontSize: "10px", textAlign: "center" }}>{item.periodo}</td>
                                                    <td style={{ fontSize: "10px", textAlign: "center" }}>{item.numdocumento.trim()}</td>
                                                    <td style={{ fontSize: "10px", textAlign: "center" }}>{item.tippago.trim()}</td>
                                                    <td style={{ fontSize: "10px", textAlign: "center" }}>{item.banco.trim()}</td>
                                                    <td style={{ fontSize: "10px", textAlign: "center" }}>{moment.utc(item.fecha).format('DD/MM/YYYY')}</td>
                                                    <td style={{ fontSize: "10px", textAlign: "center" }}>{formatMoneda(item.monto === null ? '0,00' : item.monto.toString().replace('.', ','), ',', '.', 2)}</td>
                                                    <td style={{ fontSize: "10px", textAlign: "center" }}>{item.status.trim()}</td>
                                                    <td align="center" >
                                                       <button  onClick={eliminarPago(item.numfactura, item.periodo, item.status)} className="btn rounded-pill btn-danger"><i className="fa fa-trash-alt"></i> </button>
                                                    </td>
                                                </tr>

                                            ))
                                        } 
                                    </tbody>

                                </TblContainer>
                                {/*<TblPagination />*/}
                                
                            </div>
                       
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );

}

export default TablaRelacionPagosWeb;
